
import { GDSProduct } from "@/models/GDSProduct";
import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslationModel, CarbonSavingsModel } from "../../models/product";
import CarbonSavingsCalculation from "./CarbonSavingsCalculation";
import { EventBus } from "@/events";
import http from "../../services/Http";
import { UiState } from "../../../src/modules/ProductConfigurator/models";

@Component({
    components: {
        CarbonSavingsCalculation
    }
})
export default class DiyVariantItem extends Vue {
    protected gdsVariants!: GDSProduct[];
    protected carbonSavingsProductStates: Array<UiState<boolean>> = [];
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.gdsVariants =  JSON.parse(this.$attrs.gdsvariant);

        this.gdsVariants.map(x => {
            this.carbonSavingsProductStates.push({ id: x.id} as UiState<boolean>);
        });
    }

    protected toggleCarbonSavingsInfo(gdsVariant: GDSProduct) {
        const productStateIndex = this.carbonSavingsProductStates.findIndex(s => s.id === gdsVariant.id);
        if (productStateIndex !== -1) {
            const productState = this.carbonSavingsProductStates[productStateIndex];
            productState.state = !productState.state;
            this.carbonSavingsProductStates.splice(productStateIndex, 1, productState);
        }
    }

    protected mounted() {
        EventBus.$on("selectedECOvariant", (carbonSavingsModel: CarbonSavingsModel, isGDS: boolean, quantity: number) => {
            http.get<string>(`${window.location.origin + window.location.pathname}.GetECOProductItem?variantId=${carbonSavingsModel.ecoVariantId}&quantity=${quantity}`)
            .then(data => {
                const productsData = JSON.parse(data);
                const currentVariant = this.gdsVariants.find(x => x.id === carbonSavingsModel.currentVariantId);
                const currentVariantIndex = this.gdsVariants.findIndex(x => x.id === carbonSavingsModel.currentVariantId);
                this.carbonSavingsProductStates.push({ id: carbonSavingsModel.ecoVariantId, state: false} as UiState<boolean>);
                const modifiedQuantity = Math.ceil(carbonSavingsModel.packagingFactor * productsData.quantity);
                productsData.quantity = modifiedQuantity;
                if (currentVariant) {
                    productsData.consumerName = currentVariant.consumerName;
                }
                if (productsData.packagingQuantity === quantity) {
                    productsData.packagingQuantity = modifiedQuantity;
                }
                this.gdsVariants[currentVariantIndex] = productsData;
                this.$forceUpdate();
            });
        });
    }

    protected virtualItemClassExists(variant: GDSProduct) {
        return variant.virtualItemClass !== "";
    }

    protected getVariantId(variant: GDSProduct) {
        return variant.virtualItemClass !== "" ? variant.id : "";
    }

    protected getCarbonSavingsProductState(product: GDSProduct) {
        return this.carbonSavingsProductStates.find(ps => ps.id === product.id);
    }

    protected showCarbonSavingsInfo(product: GDSProduct): boolean {
        const productState = this.getCarbonSavingsProductState(product);
        if (productState) {
            return productState.state;
        }
        return false;
    }
}
